import { useQuery } from '@tanstack/react-query';
import type { Team } from 'api-client';

import { getPersistedAvailableOrgs } from '@/lib/localStorage/persistedAvailableOrgs';

export function useAvailableOrgs(userId: number | undefined) {
  return useQuery<Team[]>({
    queryKey: ['availableOrgs', userId],
    queryFn: async () => {
      // OrgContext.loadTeams owns refresh via setQueryData; this never
      // actually runs unless cache is empty (in which case localStorage
      // is also empty). Return persisted snapshot or empty.
      return getPersistedAvailableOrgs(userId) ?? [];
    },
    enabled: !!userId,
    initialData: () => getPersistedAvailableOrgs(userId),
    initialDataUpdatedAt: () => 0,
    staleTime: Infinity,
  });
}
